import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../../../Entity'

export function getUserProfileHeaderInfoItemActions(onClick) {
  return {
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: {
      onClick,
    },
    [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: {
      onClick,
    },
  }
}

export function getUserProfileHeaderInfoItemActionsProps({
  actionQaNames,
  name,
}) {
  const qaNames = actionQaNames[name]

  return qaNames
    ? {
        buttonsProps: {
          [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD]: {
            qaName: qaNames.add,
          },
          [ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT]: {
            qaName: qaNames.edit,
          },
        },
      }
    : undefined
}
